import { shape } from 'prop-types';
import PropTypes from 'prop-types';

export const prescriberInfo = shape({
  prescriberInfo: PropTypes.shape({
    id: PropTypes.string,
    prescriber: PropTypes.shape({
      name: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string
      }),
      identification: PropTypes.shape({
        externalRegistrationId: PropTypes.string
      }),
      address: PropTypes.shape({
        addressLine1: PropTypes.string,
        addressLine2: PropTypes.string,
        city: PropTypes.string,
        stateProvince: PropTypes.string,
        postal: PropTypes.string,
        coutnryCode: PropTypes.string
      }),
      communicationNumbers: PropTypes.shape({
        phone: PropTypes.shape({
          number: PropTypes.string
        }),
        fax: PropTypes.shape({
          number: PropTypes.string
        })
      })
    }),
    service: PropTypes.shape({
      activeEndTime: PropTypes.string
    })
  }),
});